import React from 'react';

import { Feature } from 'config/features';

import useConsent, { ConsentType } from 'hooks/useConsent';

import { getFeatureActive } from 'utility/Check/getFeatureActive';

import Sentry from './';

const SentryInit = () => {
    const hasConsent = useConsent();

    Sentry(getFeatureActive(Feature.Sentry), hasConsent[ConsentType.Analytic]);

    return <></>;
};

export default React.memo(SentryInit);
